import { CssColor, KeyOf } from '@trilean/n7';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type CSSStyleColorDeclaration = 'fill' | Extract<KeyOf<CSSStyleDeclaration, string>, `${any}${'C' | 'c'}olor`>;

export function getChildComputedStyleProperty<K extends keyof HTMLElementTagNameMap>(
  parent: Node,
  tagName: K,
  classNames: string[],
  propertyName: KeyOf<CSSStyleDeclaration, string>,
): string {
  const e = document.createElement(tagName);
  e.classList.add(...classNames);
  parent.appendChild(e);
  const r = getComputedStyle(e)[propertyName];
  e.remove();
  return r;
}

export function getComputedStyleProperty<K extends keyof HTMLElementTagNameMap, R>(
  tagName: K,
  classNames: string[],
  propertyName: KeyOf<CSSStyleDeclaration, string>,
): string {
  return getChildComputedStyleProperty(document.body, tagName, classNames, propertyName);
}

export function getThemeComputedStyleProperty<K extends keyof HTMLElementTagNameMap>(
  themeClassName: string | null | undefined,
  tagName: K,
  classNames: string[],
  propertyName: KeyOf<CSSStyleDeclaration, string>,
): string {
  let container: Element | undefined;
  if (!!themeClassName) {
    container = document.createElement('div');
    container.className = themeClassName;
    document.body.appendChild(container);
  }
  const r = getChildComputedStyleProperty(container ?? document.body, tagName, classNames, propertyName);
  container?.remove();
  return r;
}

export function getThemeComputedStyleColor<K extends keyof HTMLElementTagNameMap>(
  themeClassName: string | null | undefined,
  tagName: K,
  classNames: string[],
  propertyName: CSSStyleColorDeclaration,
): CssColor {
  return <CssColor>getThemeComputedStyleProperty(themeClassName, tagName, classNames, propertyName);
}

export function getThemePalette(theme: string | undefined, color: 'primary' | 'accent' | 'warn'): CssColor {
  theme = !!theme ? `${theme} mat-${color}` : `mat-${color}`;
  return <CssColor>getThemeComputedStyleColor(theme, 'div', ['mat-pseudo-checkbox-checked'], 'backgroundColor');
}
